<template>
  <div id="app" class="app">
    <!-- Mobile Overlay -->
    <div v-if="showMobileSidebar" class="mobile-sidebar-overlay" @click="setMobileSidebar(false)"></div>

    <AppSidebar v-if="showSidebar"
                :class="['app-body-sidebar-visible', { 'mobile-sidebar-open': showMobileSidebar }]" />
    <AppHeaderAlternative v-if="showSidebar" ref="appHeaderAlt" id="app-header"
                          :class="{ 'app-body-sidebar': showSidebar, 'sidebar-collapsed': sidebarCollapsed }"
                          />
    <AppHeader v-if="!showSidebar" ref="appHeader" id="app-header" />
    <!-- <BOffcanvas v-model="showOffcanvas" @hidden="toggleShowOffcanvas" placement="start" :style="{ width: sidebarWidth + 'px' }">
    <AppSidebar />
    </BOffcanvas> -->
    <div  id="app-body"
          class="app-body"
          :class="{ 'app-body-sidebar': showSidebar, 'sidebar-collapsed': sidebarCollapsed }">
      <main class="main">
        <BOverlay :show="!isClientReady || appLoading" variant="dark" opacity="0.5">
          <template #overlay>
            <default-spinner v-if="!isClientReady || appLoading" />
            <div v-if="(isMatrixPage && !hasData) && !appLoading && isClientReady" class="text-white">
              <h4>{{ $t('Webportal.NoData') }}</h4>
            </div>
          </template>
          <div id="app-content" class="container-fluid"
              :class="{ 'container-fluid-fix': fixContainerFluidPadding }">
            <router-view v-slot="{ Component }">
              <keep-alive include="CheckExplorer" v-if="shouldKeepAlive">
                <component  :is="Component" :key="componentKey" />
              </keep-alive>
              <component  v-else :is="Component" :key="componentKey" />
            </router-view>
          </div>
        </BOverlay>
      </main>
    </div>
    <AppFooter v-if="!showSidebar" id="app-footer" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AppHeader from '@/components/AppHeader';
import AppSidebar from '@/componentsv3/AppSidebar-APP_TARGET';
import AppFooter from '@/components/AppFooter-APP_TARGET';
import AppHeaderAlternative from './componentsv3/AppHeaderAlternative-APP_TARGET';
import DefaultSpinner from '@/componentsv3/DefaultSpinner.vue';
export default {
  name: 'Full',

  components: { AppHeader, AppSidebar, AppFooter, AppHeaderAlternative, DefaultSpinner },

  computed: {
    ...mapGetters('app', ['sidebarCollapsed', 'sidebarWidth', 'showSidebar', 'showOffcanvas', 'showMobileSidebar']),
    ...mapGetters('clientData', [ 'isClientReady', 'appLoading', 'hasData' ]),
    shouldKeepAlive() {
      const n = this.$route.name;
      return n === 'CheckExplorer'
        || n === 'SurveyRevisionExplorer'
        || n === 'SurveyImprovementExplorer'
        || n === 'SurveyRevision'
        || n === 'SurveyImprovement';
    },

    componentKey() {
      const n = this.$route.name;
      const p = this.$route.params;
      if ((n === 'SurveyRevision' || n === 'SurveyImprovement') && p) {
        return this.$route.path.replace(new RegExp('/' + p.id), '');
      }
      return this.$route.path;
    },

    name() {
      return this.$route.name;
    },

    list() {
      return this.$route.params.list;
    },

    fixContainerFluidPadding() {
      if (APP_TARGET === "bmw")
        return this.$route.name == 'CX';
      else
        return false;
    },
    isMatrixPage() {
      return this.$route.name === 'Matrix';
    },
  },

  methods: {
    ...mapActions('app', ['setMobileSidebar']),

  }
}
</script>

<style lang="scss" scoped>
.container-fluid-fix {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.app-body-sidebar-visible {
  // Desktop: immer sichtbar bei left: 0
  @media (min-width: 992px) {
    left: 0;
  }

  // Mobile: standardmäßig versteckt
  @media (max-width: 991px) {
    position: fixed;
    left: -288px;
    top: 0;
    bottom: 0;
    z-index: 1040;
    transition: left 300ms ease-out;
  }
}

.app-body-sidebar-visible.mobile-sidebar-open {
  @media (max-width: 991px) {
    left: 0;
    width: 288px;
  }
}

.mobile-sidebar-overlay {
  display: none;

  @media (max-width: 991px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1039;
    animation: fadeIn 300ms ease-out;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>

<!-- Nicht-scoped Styles für komponentenübergreifende Regeln -->
<style lang="scss">
.app-body-sidebar {
  margin-left: 288px;
  transition: margin-left 150ms ease-out;
}

@media (max-width: 991px) {
  .app-body-sidebar {
    margin-left: 0;
  }
}

@media (min-width: 992px) {
  .app-body-sidebar.sidebar-collapsed {
    margin-left: 90px;
  }
}
</style>
